<template>
    <div id="customer">
        <div class="ui fluid container">
            <div v-if="$store.state.is_login === true" class="ui stackable grid">
                <div class="three wide column">
                    <Sidebar v-if="$store.state.initialize_statuses.main"></Sidebar>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/sidebar.png" alt="">
                </div>

                <div class="thirteen wide column">
                    <TopMenu v-if="$store.state.initialize_statuses.main"></TopMenu>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/top_menu.png" alt="">

                    <div class="ui main segment"
                        style="min-height: calc(100vh - 250px);">
                        <Breadcrumb v-if="$store.state.initialize_statuses.main"></Breadcrumb>
                        <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/breadcrumb.png" alt="">

                        <router-view v-if="$store.state.initialize_statuses.main"></router-view>
                        <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/main.png" alt="">
                    </div>

                    <FooterBar v-if="$store.state.initialize_statuses.main"></FooterBar>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/footer.png" alt="">
                </div>

                <DatetimerangeModal v-if="$store.state.initialize_statuses.main"
                    :options="$store.state.element_ui_datepicker_daterange_options.shortcuts"
                    :channel="date_picker_modal.channel"
                    :type="date_picker_modal.type"
                ></DatetimerangeModal>

                <ScannerModal v-if="$store.state.initialize_statuses.main"></ScannerModal>

            </div>
            <div v-else-if="$store.state.is_login === false">
                <div class="ui container">
                    <Login></Login>
                    <FooterBar></FooterBar>
                </div>
            </div>
            <div v-else class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">
                    <!-- 驗證身份... -->
                    {{ $t('ui.general.verify_staff') }}...
                </div>
            </div>
        </div>
        <div class="ui basic modal" ref="login_expiration_hint_modal">
            <div class="ui icon header">
                <i class="wait icon"></i>
                <!-- 閒置 -->
                {{ $t('ui.pages.partials.login_expiration_hint_modal.idle') }}
            </div>
            <div class="content" style="color: white;">
                <p>
                    <!-- 系統偵測到你很久沒有動作了，再過{{ human_remaining_time }}就會自動登出。 -->
                    {{
                        $t('ui.pages.partials.login_expiration_hint_modal.content', {
                            time: human_remaining_time
                        })
                    }}
                </p>
            </div>
            <div class="actions">
                <div class="ui green ok inverted button" @click="extend_login_timeout">
                    <i class="checkmark icon"></i>
                    <!-- 我回來了 -->
                    {{ $t('ui.pages.partials.login_expiration_hint_modal.i_am_back') }}
                </div>
            </div>
        </div>

        <div
            v-if="$store.state.is_login && $store.state.customer.is_can_use_scanner"
            @click="$bus.$emit('toggle_scanner_modal')"
            :class="{hide: is_hide_icon_toggle_scanner_modal}"
            class="icon_toggle_scanner_modal pointer mobile only">
            <i class="large circular inverted icon z-depth-2"
            :class="{
                'barcode': !is_scanner_modal_opend,
                'red remove': is_scanner_modal_opend,
            }">
            </i>
        </div>
    </div>
</template>

<script>
import Sidebar from '@partials/customer/sidebar.vue'
import TopMenu from '@partials/customer/top_menu.vue'
import FooterBar from '@partials/customer/footer.vue'
import Breadcrumb from '@partials/customer/breadcrumb.vue'
import ScannerModal from '@scanner/customer/modal.vue'
import DatetimerangeModal from '@toolbox/date_picker_modal/main.vue'
import Login from '@login/customer_main.vue'
import Keyboard from '@javascripts/keyboard.js'

var login_validation_timer
var login_timeout_hint_timer
var ActionCablesModule = require('@config/action_cable')
var ActionCables = new ActionCablesModule()

export default {
    data() {
        return {
            clock: {
                ticker: null,
                remaining_time: 0,
            },
            action_cables: [],
            is_hide_icon_toggle_scanner_modal: false,
            is_scanner_modal_opend: false,
            date_picker_modal: {
                channel: "",
                type: ""
            },
        }
    },
    computed: {
        language() {
            return this.$store.state.language
        },
        human_remaining_time() {
            var moment = this.$moment
            var eventMDuration = moment.duration(Math.floor(this.clock.remaining_time / 1000), "seconds")
            var eventDurationString = ""
            if (eventMDuration.days() > 0)
                eventDurationString += " " + eventMDuration.days() + this.$t('ui.general.day')
            if (eventMDuration.hours() > 0)
                eventDurationString += " " + eventMDuration.hours() + this.$t('ui.general.hour')
            if (eventMDuration.minutes() > 0)
                eventDurationString += " " + eventMDuration.minutes() + this.$t('ui.general.minute')
            if (eventMDuration.seconds() > 0)
                eventDurationString += " " + eventMDuration.seconds() + this.$t('ui.general.second')

            return eventDurationString.trim()
        },
    },
    async created() {
        await this.init()

        this.clock.ticker = setInterval(() => {
            if (this.clock.remaining_time >= 1000) {
                this.clock.remaining_time = this.clock.remaining_time - 1000
            }
        }, 1000)

        // document.title = this.$t('ui.page_titles.' + this.$route.name) + " | 客戶界面"
        document.title = this.$t('ui.page_titles.' + this.$route.name) + " | "+this.$t("ui.page_titles.customer_pages")
        this.toggle_scanner_modal_keyboard_shortcut()
    },
    mounted() {
        this.$bus.$off("toggle_scanner_modal")
        this.$bus.$on("toggle_scanner_modal", (value = "toggle") => {
            this.toggle_scanner_modal(value)
        })

        this.$bus.$off("date_picker_modal")
        this.$bus.$on("date_picker_modal", (value = "toggle", type="daterange", channel = "") => {
            this.date_picker_modal = {
                channel: channel,
                type: type,
            }
            this.toggle_date_picker_modal(value)
        })

        this.$bus.$off("is_print_waybill")
        this.$bus.$on("is_print_waybill", (
            core_waybill_number,
            event_bus_name = "", // 雙向 event_bus
            max_diff_second = 1, //重複號碼秒數上限, 預設60s
            max_length = 10 //最多號碼數量, 預設10筆
        ) => {
            var result = this.is_print_waybill(
                core_waybill_number,
                max_diff_second,
                max_length
            )

            if (event_bus_name) {
                this.$bus.$emit(event_bus_name, result)
            } else {
                if (result.error) {
                    alert(result.error)
                }
            }
        })

        this.$store.state.style.width = $(window).width()
        this.$store.state.style.height = $(window).height()
        $(window).resize(() => {
            this.$store.state.style.width = $(window).width()
            this.$store.state.style.height = $(window).height()
        })
    },
    watch: {
        '$route' (to, from) {
            console.log("customer Layout watch")

            // 當route變動時重設登入逾時時間
            this.extend_login_timeout()

            // Page Title
            // document.title = this.$t('ui.page_titles.' + to.name) + " | Neuron"
            document.title = this.$t('ui.page_titles.' + to.name) + " | "+this.$t("ui.page_titles.customer_pages")

            this.set_current_page_breadcrumb()
        },
        // 處理在store無法切換i18n的文字
        'language': {
            handler(value) {
                try {
                    this._i18n.locale = value
                    this.cahnge_language_in_store_js_text()
                    // console.log(this.$route.name)
                    // document.title = this.$t('ui.page_titles.' + this.$route.name) + " | Neuron"
                    document.title = this.$t('ui.page_titles.' + this.$route.name) + " | "+this.$t("ui.page_titles.customer_pages")
                } catch (e) {
                    console.log(e)
                    this.$noty.error(e)
                }
            },
            deep: true,
        },
    },
    methods: {
        wait(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },
        async init() {
            try {
                await new Promise(resolve => {
                    var reslut = localStorage.getItem("language") || 'zh-TW'
                    this.$store.state.language = reslut
                    resolve()
                })
                await new Promise(resolve => {
                    this.$store.commit('set_current_scope', 'customer')
                    resolve()
                })
                await this.validate_login()
                await new Promise(resolve => {
                    this.$store.state.is_login = true
                    resolve()
                })
                await this.$store.dispatch('customer/fetch_routes')
                await this.$store.dispatch('customer/fetch_customer')
                await this.$store.dispatch('customer/fetch_notifications')
                await this.$store.dispatch('customer/fetch_papers_label_infos')
                await this.setting_service_theme()
                // await this.$store.dispatch('customer/fetch_customer_partitions')
                await new Promise(resolve => {
                    // this.$noty.information("客戶界面初始化完畢")
                    this.$noty.information(this.$t('ui.general.initialize_complete'))
                    this.$store.state.initialize_statuses.main = true
                    resolve()
                })
                /*
                 * Current Page
                 */
                await this.set_current_page_breadcrumb()

            } catch (e) {
                console.log(e)
                switch (e) {
                    default:

                }
            } finally {
            }
        },
        validate_login() {
            if (localStorage.getItem("customer_authentication_token")) {
                // 已經登入
                if (localStorage.getItem("customer_expired_at") > this.$moment.utc().format()) {
                    // 登入尚未逾時
                    var url = this.$store.state.settings.authorize_url
                    return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                        .then(response => {
                            if (response.data.status == "success") {
                                this.extend_login_timeout()
                                return Promise.resolve()
                            } else {
                                return Promise.reject(response.data)
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                switch (error.response.status) {
                                    default:
                                    this.errors.push(error.response.status + ' ' + error.response.statusText)
                                }
                                // this.$noty.error("登入失敗: " + error.response.status + ' ' + error.response.statusText)
                                this.$noty.error(
                                    this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                    error.response.status + ' ' + error.response.statusText
                                )
                            } else if (error.errors) {
                                for (var message in error.errors) {
                                    // this.$noty.error("登入失敗: " + message + " " + error.errors[message])
                                    this.$noty.error(
                                        this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                        message + " " + error.errors[message]
                                    )
                                }
                            } else {
                                // this.$noty.error("登入失敗: "+ this.$t('ui.general.server_offline'))
                                this.$noty.error(
                                    this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                    this.$t('ui.general.server_offline')
                                )
                            }
                            this.clear_login_session()
                            this.$store.state.is_login = false
                            return Promise.reject("authorize failed")
                        })
                } else {
                    // 登入逾時
                    this.clear_login_session()
                    this.$store.state.is_login = false
                    this.$noty.error(
                        this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                        this.$t('ui.pages.login.errors.timeout')
                    )

                    if (this.$store.state.initialize_statuses.main) {
                        this.redirect_to('/customer')
                    } else {
                        return Promise.reject("login timeout")
                    }
                }
            } else {
                // 尚未登入
                this.$store.state.is_login = false
                return Promise.reject("not logged in")
            }
        },
        setting_service_theme() {
            var console_log_content = "", file_name, file
            var service_name = this.$store.state.customer.customer.provider_node.service_name

            try {
                file_name = service_name + "/config.json"
                file = require("../../config/services/" + file_name)
            } catch (e) {
                // not find file
                file_name = "default/config.json"
                file = require("../../config/services/" + file_name)
            } finally {
                // 捲軸樣式
                document.body.classList.add(service_name)
                this.$store.state.customer.service_config = file
                console_log_content += "    service: " + file_name + "\n"
            }

            console.log(
                "//=============== \n" +
                "  Now service configs: \n" +
                    console_log_content +
                "  All file path: config/services/ \n" +
                "//=============== \n"
            )

            return Promise.resolve()
        },
        set_current_page_breadcrumb() {
            if (this.$route.meta.breadcrumb) {
                this.$store.state.breadcrumbs = this.$route.meta.breadcrumb
            }
            return Promise.resolve()
        },

        reserve_login_validation() {
            // 清除計時器們
            clearTimeout(login_validation_timer)
            clearTimeout(login_timeout_hint_timer)
            // 計算預約檢查時間
            var next_validation_offset = this.$moment(localStorage.getItem("customer_expired_at")) - this.$moment()
            this.clock.remaining_time = next_validation_offset
            var next_validation_at = this.$moment().utc(this.$moment().add(next_validation_offset, 'milliseconds')).format()
            var timeout_hint_offset = next_validation_offset - this.$store.state.global_setting.login_expiration_hint_preset*1000
            // console.log("下次檢查時間是" + next_validation_at)
            // 設置檢查計時器
            login_validation_timer = setTimeout(() => {
                this.validate_login()
            }, next_validation_offset)
            // 設置逾時提示計時器
            login_timeout_hint_timer = setTimeout(() => {
                if ( localStorage.getItem("customer_expired_at") > next_validation_at) {
                    // 當能通過下次逾時檢查時
                    // console.log("你能通過下次逾時檢查，我就不提示囉")
                    console.log(
                        this.$t('ui.pages.login.pass_next_timeout_will_dont_warn')
                    )
                } else {
                    // 當不能通過下次逾時檢查時
                    this.show_login_timeout_hint()
                }
            }, timeout_hint_offset)
        },
        show_login_timeout_hint() {
            $(this.$refs.login_expiration_hint_modal)
                .modal({
                    dimmerSettings: {opacity: 0.8},
                    closable: false,
                })
                .modal('show')
        },
        extend_login_timeout() {
            localStorage.setItem("customer_expired_at", this.$moment.utc(
                this.$moment().add(
                    this.$store.state.global_setting.login_expiration_period,
                    'second'
                )
            ).format())
            this.reserve_login_validation()
        },
        clear_login_session() {
            clearTimeout(login_validation_timer)
            clearTimeout(login_timeout_hint_timer)
            localStorage.removeItem("customer_expired_at")
            localStorage.removeItem("customer_authentication_token")
        },
        redirect_to(path) {
            window.location.replace(path)
        },
        logout() {
            this.clear_login_session()

            if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                this.init()
            } else {
                this.redirect_to('/customer')
            }
        },
        window_keydown(e) {
            var keyboard = new Keyboard(e)

            // for Honeywell android 7
            // console.log(keyboard.key)
            // if (this.is_phone_device && keyboard.key == 'Unidentified') {
            //     console.log('yes!!!!!!!!!!!!!!!!')
            //     this.phone_device_unidentified_count += 1
            //     if (this.phone_device_unidentified_count >= 2) {
            //         this.toggle_scanner_modal("toggle")
            //         this.phone_device_unidentified_count = 0
            //     }
            //     setTimeout(() => {
            //         console.log('Clear phone_device_unidentified_count!')
            //         this.phone_device_unidentified_count = 0
            //     }, 500)
            // }

            // ctrl + Q
            if ((keyboard.key_code == 81 && keyboard.ctrl) || keyboard.key == "WakeUp") {
                this.toggle_scanner_modal("toggle")
            }
        },
        toggle_is_hide_icon_toggle_scanner_modal(value = false) {
            this.is_hide_icon_toggle_scanner_modal = value
        },
        toggle_scanner_modal_keyboard_shortcut() {
            // $(window).bind("keydown", this.window_keydown)
            $(window).bind("keyup", this.window_keydown)
        },
        toggle_scanner_modal(value = "toggle") {
            var that = this
            console.log(this.$store.state.customer.is_can_use_scanner)
            if (this.$store.state.customer.is_can_use_scanner) {
                $('.ui.scanner.modal')
                    .modal({
                        dimmerSettings: {opacity: 0},
                        autofocus: false,
                        inverted: true,
                        duration: 200,
                        onShow(){
                            that.is_scanner_modal_opend = true
                            that.$bus.$emit('set_modal_opened', true)
                        },
                        onHidden(){
                            that.is_scanner_modal_opend = false
                            that.$bus.$emit('set_modal_opened', false)
                        },
                    })
                    .modal(value)
            }
        },
        toggle_date_picker_modal(value = "toggle") {
            var that = this
            $('.ui.modal.datetimerange')
                .modal({
                    closable: false,
                    autofocus: false,
                    onShow() {
                        that.is_hide_icon_toggle_scanner_modal = true
                        $('.ui.dimmer.modals').css("background", "rgba(0,0,0,0.85)")
                    },
                    onHidden() {
                        that.is_hide_icon_toggle_scanner_modal = false
                    },
                })
                .modal(value)
        },

        /**
         * This function is check can use print waybill
         * Return {
         *   status: String(success || failure),
         *   error: String
         * }
         *
         * Parameter help
         *   core_waybill_number: 號碼,
         *   max_diff_second: 重複號碼秒數上限, 預設60s,
         *   max_length: 最多號碼數量, 預設10筆,
         *
         * @Auth Eziopu <eziopu@mynet.com.tw>
         * @Edit Date 2018-01-08
         */
        is_print_waybill(
            core_waybill_number,
            max_diff_second = 60,
            max_length = 10
        ) {
            /* localStorage use Array JSON
                [{
                    "number": 123,
                    "created_at": "2018/xx/xx xx:xx:xx"
                },{
                    "number": 456,
                    "created_at": "2018/xx/xx xx:xx:xx"
                },{...}]
            */
            var result = {
                "status": "failure",
                "error": ""
            }
            var print_waybills = []
            var print_waybill_history = localStorage.getItem('print_waybill_history')

            // 第一次存 localStorage
            if (!print_waybill_history) {
                this.set_print_waybill_history(
                    print_waybills, core_waybill_number
                )
                result.status = "success"

            } else {
                // is String to Array Json
                print_waybills = $.parseJSON('[' + print_waybill_history + ']')

                // 存在於 localStorage 的core_waybill
                var current_core_waybill = _.find(print_waybills, (print_waybill) => {
                    return print_waybill.number == core_waybill_number
                })

                // 存在 localStorage 內
                if (current_core_waybill) {
                    // 比較時間
                    var created_at = this.$moment(current_core_waybill.created_at)
                    var diff_result = this.$moment().diff(created_at, 'second')

                    // 大於 連續產標時間 可放入 localStorage 內
                    if (diff_result > max_diff_second) {
                        // 刪除 當前 localStorage 內的 core_waybill
                        _.remove(print_waybills, (object) => {
                            return object.number == core_waybill_number
                        })

                        this.set_print_waybill_history(
                            print_waybills, core_waybill_number
                        )
                        result.status = "success"

                    } else {
                        result.status = "failure"
                        result.error = "您無法在"+max_diff_second+"秒內 連續印標"
                    }

                // 不存在 localStorage 內
                } else {
                    this.set_print_waybill_history(
                        print_waybills, core_waybill_number
                    )
                    result.status = "success"
                }

                // 大於
                if (print_waybills.length > max_length) {
                    // 刪除最舊一筆
                    print_waybills.shift()
                    this.set_print_waybill_history(print_waybills)
                }
            }
            console.log(
                'print_waybill_history',
                localStorage.getItem('print_waybill_history')
            )
            return result
        },
        set_print_waybill_history(results, core_waybill_number = "") {
            /* results 範例
                [{
                    "number": 123,
                    "created_at": "2017/xx/xx xx:xx:xx"
                },{...}]
            */
            if (core_waybill_number) {
                results.push({
                    "number": core_waybill_number,
                    "created_at": this.$moment().format('YYYY/MM/DD HH:mm:ss')
                })
            }

            var new_array = []
            _.forEach(results, (result) => {
                new_array.push(
                    JSON.stringify(result)
                )
            })

            localStorage.setItem('print_waybill_history',
                new_array.toString()
            )
        },
        /*
         * 處理在store無法切換i18n的文字
        **/
        cahnge_language_in_store_js_text() {
            // element_ui 時間範圍選擇
            _.map(this.$store.state.element_ui_datepicker_daterange_options.shortcuts, (shortcut) => {
                shortcut.text = this.$t(shortcut.i18n_key)
            })
        },
    },
    components: {
        Sidebar,
        TopMenu,
        FooterBar,
        Breadcrumb,
        ScannerModal,
        Login,
        DatetimerangeModal,
    },
}
</script>

<style lang="scss">
@import "../../assets/stylesheets/fonts.scss";
@import "../../assets/stylesheets/layout.scss";
@media only screen and (max-width: 843px) {
    #customer .ui.fluid.container {
        padding: 0px !important;
        margin-left: 0.5em!important;
        margin-right: 0.5em!important;
    }
}
#customer .ui.fluid.container {
    padding: 0 15px;
}

.loading_mock {
    max-width: 100%;
}
.opacity_fade {
    -webkit-animation: opacity_fade 2s infinite;
    animation: opacity_fade 2s infinite;
}
.mobile.icon_toggle_scanner_modal {
    position: fixed;
    z-index: 8080;
    bottom: 18px;
    right: 6px;
}

@-webkit-keyframes opacity_fade {
    0% {opacity: 0.5;}
    50% {opacity: 0.3;}
    100% {opacity: 0.5;}
}

@keyframes opacity_fade {
    0% {opacity: 0.5;}
    50% {opacity: 0.3;}
    100% {opacity: 0.5;}
}
</style>
